import { ProductCard } from '~/features/ProductList/components/ProductCard';
import { Loop54Product } from '~/services/loop54/types';
import { useTranslations } from '~/services/umbraco/hooks';
import { RefObject, memo, useCallback, useEffect, useMemo } from 'react';
import { ModuleCarousel } from '~/templates/blocks/shared/ModuleCarousel';
import { ILink } from '~/lib/data-contract/umbraco-api-model';

type Props = {
    data: Loop54Product[] | undefined;
    headline: string | undefined;
    setHasProducts?: (status: boolean) => void;
    inputRef?: RefObject<HTMLDivElement | null>;
    link?: ILink;
};

function CarouselWithItems({ data, headline, inputRef, link, setHasProducts }: Props) {
    const { translate } = useTranslations();

    const productsWithPrices = useMemo(() => {
        return (
            data?.map((item, index) => {
                return {
                    key: item.SKU + index,
                    product: item,
                };
            }) || []
        );
    }, [data]);

    const renderProductCard = useCallback(
        (item: { key: string; product: Loop54Product }) => (
            <ProductCard
                key={item.key}
                product={item.product}
                translate={translate}
                itemListName={headline}
            />
        ),
        [translate, headline],
    );

    const productItems = useMemo(
        () => productsWithPrices?.map(renderProductCard),
        [productsWithPrices, renderProductCard],
    );

    useEffect(() => {
        if (setHasProducts) setHasProducts(productItems.length > 0);
    }, [productItems, setHasProducts]);

    if (productItems?.length < 1) {
        return null;
    }

    return (
        <ModuleCarousel
            items={productItems}
            headline={headline}
            isProducts
            inputRef={inputRef}
            link={link}
        />
    );
}

export default memo(CarouselWithItems);
